import { Language } from '@/types/i18n';

import { axios } from './axios';

export const updateLanguageHeader = function (lang = Language.English) {
  axios.defaults.headers['x-language'] = lang;
};
